<template>
    <v-card
      class="mx-auto"
      max-height="300"
      min-height="300"
    >
        <v-img
            :src="getImage"
            height="245"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.6)"
        >
        <v-card-title>
          {{vt.photographer_name}}
        </v-card-title>
        </v-img>

        <v-divider></v-divider>
        <v-card-actions>
          <div class="text-caption">
            <b>Publish on:</b> <span>{{publishDate}}</span>
          </div>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click.stop="editVt()"
                text
            >
              <v-icon>{{ icons.edit }}</v-icon>

            </v-btn>

            <v-btn
                color="primary"
                text
                :loading="loading"
                @click.stop="showDeleteDialog=true"
            >
                <v-icon>{{ icons.delete }}</v-icon>
            </v-btn>
        </v-card-actions>
        <DeleteDialog :data="{id:vt.id}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deleteVanglainiThlalak"/>

    </v-card>

</template>
<script>
import urlUtils from '@/utils/urlUtils'
import { mdiPencil, mdiDelete } from '@mdi/js'
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import * as dateFormats from '@/constants/dateFormats'
import vtApi from '@/api/vtApi'
export default {
  props: {
    vt: {
      type: Object,
      required: true,
      default: null
    }
  },
  components: {
    DeleteDialog
  },
  computed: {
    getImage () {
      if (this.vt.image !== undefined) {
        const k = urlUtils.getImageUrl(this.vt.image.path)
        this.$log.info(k)
        return k
      }
      return ''
    },
    publishDate () {
      return this.$moment(this.vt.publish_date).format(dateFormats.DDMMYY)
    }
  },
  data () {
    return {
      loading: false,
      showDeleteDialog: false,
      icons: {
        edit: mdiPencil,
        delete: mdiDelete
      }
    }
  },
  methods: {
    async deleteVanglainiThlalak (data) {
      this.$log.info('delete image callback ', [data])
      if (data !== null && data.id !== undefined) {
        try {
          this.loading = true
          await vtApi.delete(data.id)
        } finally {
          this.loading = false
        }
      }

      this.$emit('delete_success')
    },
    editVt () {
      this.$router.push({ path: '/vanglaini-thlalak/edit/' + this.vt.id })
    }
  }
}
</script>
